<template>
    <div class="container-bary">
        <v-chart :options="option"  ref="ff" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'



export default {
  name: 'barChartY2',
  props: {  
     ids:String,
     bw:{
       type:Number,
       default:14,
     }
  },
  data () {  
    return {     
      
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
       this.ff=this.$refs.ff,

    this.option = {  
          tooltip: {
              formatter: function(params,index) {               
                    　　var result = ''             
                    　　params.forEach(function (item) {         
                            if(item.seriesId=="sale"){ //销售占比
                                result += item.seriesName +":"+ item.data + "%</br>"
                            }else if(item.seriesId=="member_num"){ //活跃会员数
                                if(item.data>10000){
                              　    result += item.seriesName +":"+ (item.data/10000) + "万</br>"
                                }
                                else{
                                  　result += item.seriesName +":"+ item.data + "</br>"
                                }
                            } else if(item.seriesId=="level_member"){ //各等级会员数
                                
                                 if(item.data>10000){
                                   
                              　    result += (params[0].name+'数') +":"+ (item.data/10000) + "万</br>"
                                }
                                else{
                                
                                  　result += (params[0].name+'数') +":"+ item.data + "</br>"
                                }
                            }
                            else{
                              result += item.seriesName +":"+ item.data + "</br>"
                            }
                           
                           
                    　　})                  
                    　　return result
                
                },
           textStyle:{
      fontSize:this.chartFontSize
      },
    trigger: "axis",
    axisPointer: {
      type: "shadow",
      
      shadowStyle:{
        color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
                offset: 1, color: 'rgba(246, 232, 87,0)' // 0% 处的颜色
            }, {
                offset: 0, color: 'rgba(234, 205, 44,0.4)' // 100% 处的颜色
            }],
            global: false // 缺省为 false
        }
      }
     
    //   label: {
    //     show: false
    //   }
    }
  },
        grid: {
            top:'20%',
            left: '8%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
             axisLabel: {             
                color:'#fff'
             },
            axisTick:{show:false},
            type: 'category',            
            data: ['V1会员', 'V2会员', 'V3会员', 'V4会员', 'V5会员'],
            splitLine: {
                    show: true,
                    lineStyle: {
                      color: '#323645',
                      type: 'solid',
                      width:1,
                    },
                    minInterval:0
                  },
        },
        yAxis: [{
               name:"会员数",
               nameRotate:320,

              nameTextStyle:{
                  color:"#fff"
              },
              axisTick:{show:false},
              axisLabel: {     
                color:'#FFFFFF',
                formatter:function (value)
                  {
                      let valueTxt = '';
                      if (value>10000) {
                          valueTxt = (value/10000)+"万" ;
                      }
                      else {
                          valueTxt = value;
                      }
                      return valueTxt ;
                  }    
              },
              type: 'value',
              splitLine: {
                    show: true,
                    lineStyle: {
                      color: '#323645',
                      type: 'dashed',
                      width:1,
                    },
                    minInterval:0
                  },             
        },{
             offset:40,
              position:"left",
              name:"销售占比",
              nameRotate:320,
              max:100,
              axisTick:{show:false},
              nameTextStyle:{
                  color:"#fff"
              },
              axisLabel: {     
                color:'#FFFFFF',
                formatter: "{value}%"
              },
              type: 'value',
              splitLine: {
                    show: false,
                    lineStyle: {
                      color: '#323645',
                      type: 'dashed',
                      width:1,
                    },
                    minInterval:0
                  },
             

        },{
             offset:80,
              position:"left",
              name:"客单价",
              axisTick:{show:false},
              nameRotate:320,
              nameTextStyle:{
                  color:"#fff"
              },
              axisLabel: { 
                color:'#FFFFFF'   
              },
              type: 'value',
            splitLine: {
                    show: false,
                    lineStyle: {
                      color: '#323645',
                      type: 'dashed',
                      width:1,
                    },
                    minInterval:0
                  },

        }],       
            legend: {
                itemWidth:6,
                itemHeight:6,
                textStyle:{
                    color:"#fff"
                },
               icon:"rect",
                data: ['各等级会员数', '活跃会员数', '销售占比', '客单价']
            },
        series: [
          {       
              id:"level_member",       
                name:"各等级会员数",
              type: 'bar',                     
              data: [120000, 100000, 90000, 70500, 30800],
              itemStyle:{
                normal:{                   
             
                    color:"#6648FF"
                  },                  
              },
              barWidth:this.barWidth         
            },            
 {             
              id:"member_num", 
               name:"活跃会员数",
              type: 'bar',                     
              data: [180000, 103000, 13000, 8000, 9500],
              itemStyle:{
                normal:{color:'#43D3C9'},                  
              },
             
              barWidth:this.barWidth         
            },
             {             
               id:"sale",  
                 name:"销售占比",
                yAxisIndex:'1',
              type: 'bar',                     
              data: [40, 28, 38, 21, 18],
              itemStyle:{
                normal:{                   
             
                    color: "#2D99FF"
                  },                  
              },
              barWidth:this.barWidth         
            },
            
            {        
                  
                name:"客单价",
                yAxisIndex:'2',
              type: 'bar',                     
              data: [750, 299, 199, 99, 150],
              itemStyle:{
                normal:{                   
             
                    color: "#8943D3"
                  },                  
              },
              barWidth:this.barWidth      
            },
            
                
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-bary2{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>